import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Storage } from '@ionic/storage';
import { ApiServiceProvider } from '../api/api-service';
import { PageBuilderMenuProvider } from '../menu/repository';
// import _ from 'lodash';

@Injectable()
export class PageBuilderVersionProvider {

  public SFGoAuth: any;
  public SFGoStorage: any;

  public path: any;
  public oldPATHUrl: any;
  public newPATH: boolean = false;
  public newPATHUrl: any;

  constructor(
    public _http: Http,
    private _storage: Storage,
    private _apiServiceProvider: ApiServiceProvider,
    private pageBuilderMenuProvider: PageBuilderMenuProvider) { 
  }

  getVersion(): Promise<any> {
    return new Promise(async (resolve) => {
      console.log('masuk sini 1, oke');
      const UserData = await this.pageBuilderMenuProvider.getUserData().catch(() => {}) || null;
      const bodyAuth = {
        auth: {
          userData: {
            companyId: UserData ? UserData.companyId : 0
          },
        },
      }
      const urlBody = JSON.stringify(bodyAuth);
      const encryptedBody = await this._apiServiceProvider.sfEncrypt(urlBody);
      this._apiServiceProvider.apiPB('GET', null, null, '/app-page/getPageVersion', false, true, encryptedBody).then(async (response: any) => {
            console.log('Load Page Success');
            if (response.data) {
              this._storage.set('pageBuilderVersion', JSON.stringify(response.data));
              resolve(response.data);
            } else {
              let version = await this._storage.get("pageBuilderVersion"); 

              try {
                version = JSON.parse(version);
              } catch (e) {
                version = version;
              }

              // console.log("TCL: Version Empty Data", version);

              if (version) {
                resolve(version);
              } else {
                version = await this._storage.set("pageBuilderVersion", JSON.stringify({})); 
                resolve(version);
                // console.log('TCL: Version Storage Empty');
              }
            }
            resolve(response);
        }, async (error) => {
          let version = await this._storage.get("pageBuilderVersion"); 

          try {
            version = JSON.parse(version);
          } catch (e) {
            version = version;
          }
          
          console.log("Error Get Version", error, version);

          if (version) {
            resolve(version);
          } else {
            version = await this._storage.set("pageBuilderVersion", JSON.stringify({})); 
            resolve(version);
            console.log('Version Storage Empty');
          }
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/pagebuilder/services/version/version-service.ts